import { RiArrowDownSLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";

export default function MenuIcon({
	sub,
	title,
	link = false,
	target = false,
	groupName = "",
}) {
	let hov_01, hov_02, hov_03, hov_04, hov_06, hov_07, hov_08, hov_09;

	let itemColor = " bg-white";
	let itemColorBG = " bg-white";
	let textColor = "text-white";
	let textColorNeg = "text-black";

	switch (groupName) {
		case "item":
			hov_01 = "group-hover/item:translate-y-4";
			hov_02 = "group-hover/item:opacity-0";
			hov_03 = "group-hover/item:opacity-100";
			hov_04 = "group-hover/item:-left-2 ";
			hov_06 = "group-hover/item:scale-100";
			hov_07 = "group-hover/item:scale-100";
			hov_08 = "group-hover/item:translate-y-0 ";
			hov_09 = "group-hover/item:rotate-45";
			textColorNeg = "text-white";
			itemColorBG = " bg-white";

			break;
		case "item2":
			hov_01 = "group-hover/item2:translate-y-4";
			hov_02 = "group-hover/item2:opacity-0";
			hov_03 = "group-hover/item2:opacity-100";
			hov_04 = "group-hover/item2:-left-2";
			hov_06 = "group-hover/item2:scale-100";
			hov_07 = "group-hover/item2:scale-100";
			hov_08 = "group-hover/item2:translate-y-0 ";
			hov_09 = "group-hover/item2:rotate-45";
			break;

		default:
			hov_01 = `group-hover:translate-y-4`;
			hov_02 = `group-hover:opacity-0`;
			hov_03 = `group-hover:opacity-100`;
			hov_04 = `group-hover:rtl:-left-2 group-hover:ltr:-right-2   `;
			hov_06 = `group-hover:scale-100`;
			hov_07 = `group-hover:scale-100`;
			hov_08 = `group-hover:translate-y-0 `;
			hov_09 = `group-hover:rotate-45`;
			itemColor = "bg-black";
			textColor = "text-shirinmehr-dark1 ";
			textColorNeg = "text-white";
			itemColorBG = "bg-black";
	}
	return sub ? (
		<div className=" flex gap-2 items-center">
			<div className=" flex items-center relative px-2">
				<RiArrowDownSLine
					className={`${hov_01} ${hov_02} ${textColor} absolute transition translate-y-0   -top-[8px] rtl:-left-1  ltr:-right-1 opacity-100`}
				/>
				<div
					className={` ${hov_03} ${hov_08}    opacity-0 r w-2 h-2  ${itemColor} transition -translate-y-4  	    absolute -top-1  rounded-full`}
				></div>
			</div>
			<div> {title}</div>
		</div>
	) : link ? (
		<a
			href={link}
			target={target ? "_blank" : undefined}
			className={`flex items-center gap-2 ${textColorNeg} `}
		>
			<div className="flex items-center gap-2 ">
				<div className=" relative flex items-center px-2">
					<div
						className={` absolute transition h-1  left-0  opacity-100  ${hov_02}   w-1 bg-black rounded-full`}
					></div>
					<RiArrowDropUpLine
						className={`absolute scale-0  ${hov_06}  ${hov_06} ${hov_09} ${hov_04}  ${hov_03} -rotate-12   rtl:-left-1 ltr:-right-1 transition opacity-0   `}
					/>
				</div>
				<div> {title}</div>
			</div>
		</a>
	) : (
		<div className="flex items-center gap-2 ">
			<div className=" relative flex items-center px-2">
				<div
					className={`${hov_02}  ${itemColorBG} absolute transition h-1  left-0  opacity-100    w-1 rounded-full`}
				></div>
				<RiArrowDropUpLine
					className={`${hov_09} ${hov_07}  ${hov_04} ${hov_03} ${textColorNeg}  absolute scale-0   -rotate-12   -left-1 transition opacity-0  0 `}
				/>
			</div>
			<div> {title}</div>
		</div>
	);
}
